/* globals $ */

import "../../../css/components/timeline.scss";

import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default class timeline {
  constructor($elem) {
    this.$elem = $elem;
    this.$points = $elem.find(".timeline-point");
    this.$tabs = $elem.find(".timeline-tab");
    this.$swiper = $elem.find(".swiper");
    this.$arrows = $elem.find(".timeline-arrow");
    this.init();
  }

  init() {
    this.$points.click((e) => {
      e.preventDefault();
      this.openTab($(e.currentTarget).data("id"));
    });

    if ($(window).width() <= 1024) {
      const swiper = new Swiper(this.$swiper[0], {
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        modules: [Navigation],
      });
      swiper.on("slideChangeTransitionEnd", () => {
        let $elem = this.$elem.find(".swiper-slide-active");
        if ($elem.length) {
          this.openTab($elem.data("id"));
        }
      });
    } else {
      this.$arrows.click((e) => {
        e.preventDefault();
        let $arrow = $(e.currentTarget);
        let $next = this.$points.filter(".active").next();
        let hasMore = $next.length ? $next.next().length : false;
        let $otherArrow = this.$elem.find(".swiper-prev");
        if ($arrow.hasClass("swiper-prev")) {
          $otherArrow = this.$elem.find(".swiper-next");
          $next = this.$points.filter(".active").prev();
          hasMore = $next.length ? $next.prev().length : false;
        }
        if ($next.length) {
          this.openTab($next.data("id"));
          $otherArrow.removeClass("swiper-button-disabled");
        }
        if (!hasMore) {
          $arrow.addClass("swiper-button-disabled");
        }
      });
    }
  }

  openTab(id) {
    this.$points.removeClass("active");
    this.$tabs.removeClass("active");
    this.$points.filter("[data-id=" + id + "]").addClass("active");
    this.$tabs.filter("[data-id=" + id + "]").addClass("active");
  }
}
